export default __webpack_public_path__ + "static/media/8.0eb47ce7.png";